import { Injectable } from "@angular/core";
import { ConfigService } from "@obg/ngx.global";

import { NewLoginFlowStep } from "./login.model";

@Injectable({
	providedIn: "root",
})
export class LoginUiConfigService {
	constructor(private configService: ConfigService) {}

	getShowRegisterButton(): boolean {
		return this.configService.get((x) => x.coreUi.login.showRegisterButton, true);
	}

	getNewLoginFlowEnabled(): boolean {
		return this.configService.get((x) => x.core.experiment?.isNewLoginFlowEnabled, false);
	}

	getNewLoginFlowSteps(): NewLoginFlowStep[] {
		return this.configService.get((x) => x.common.loginFlow?.newLoginFlow, []);
	}

	getLoginFortyDaysReview(): boolean {
		return this.configService.get((x) => x.common.login?.enableLoginFortyDaysReview, false);
	}

	getPokerLoginRedirectionDisallowed(): boolean {
		return this.configService.get((x) => x.common.login?.pokerLoginRedirectionDisallowed, true);
	}

	getPokerLoginProfileCompletenessPageEnabled(): boolean {
		return this.configService.get((x) => x.common.login?.pokerLoginProfileCompletenessPageEnabled, false);
	}

	getTaxPopupStartDate(): string | undefined {
		return this.configService.get((x) => x.commonUi?.taxPopupStartDate);
	}
}
